"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAxiosError = exports.format = void 0;
const axios_error_format_1 = require("./axios-error-format");
function format(error) {
    if (!isAxiosError(error)) {
        return error;
    }
    const formatError = new Error(error.message);
    formatError.name = error.name;
    formatError.stack = error.stack;
    formatError.code = error.code;
    formatError.isAxiosError = error.isAxiosError;
    formatError.config = {};
    for (const configKey of axios_error_format_1.CONFIG_KEYS) {
        if (error.config[configKey] !== undefined) {
            formatError.config[configKey] = configKey === 'data'
                ? formatData(error.config[configKey])
                : error.config[configKey];
        }
    }
    if (error.response) {
        formatError.response = {};
        for (const responseKey of axios_error_format_1.RESPONSE_KEYS) {
            if (error.response[responseKey] !== undefined) {
                formatError.response[responseKey] = responseKey === 'data'
                    ? formatData(error.response[responseKey])
                    : error.response[responseKey];
            }
        }
    }
    return formatError;
}
exports.format = format;
function formatData(data) {
    if (global && global.process) {
        if (data instanceof require('stream').Readable) {
            return '[Readable]';
        }
    }
    return data;
}
function isAxiosError(error) {
    return !!(error === null || error === void 0 ? void 0 : error.isAxiosError);
}
exports.isAxiosError = isAxiosError;
